import * as React from "react";
import IField, {FieldBehaviors, FieldType} from "../../metamodel/IField";
import * as Grid from "react-bootstrap/lib/Grid";
import * as Row from "react-bootstrap/lib/Row";
import * as Col from "react-bootstrap/lib/Col";
import * as Carousel from "react-bootstrap/lib/Carousel";
import Entity from "../../metamodel/Entity";
import PropertyDisplayFactory from "../../factories/PropertyDisplayFactory";
import EnumField from "../../metamodel/Fields/EnumField";
import ArrayField from "../../metamodel/Fields/ArrayField";
import ImageField from "../../metamodel/Fields/ImageField";
import {Link, RouteComponentProps} from "react-router-dom";
import {Query} from "react-apollo";
import gql from "graphql-tag";
import InputArgumentTypeFactory from "../../factories/inputArgumentTypeFactory";
import Loader from "react-loaders";
import {withRouter} from "react-router";
import {Component} from "react";
import * as Clearfix from "react-bootstrap/lib/Clearfix";
import * as AutoAffix from "react-overlays/lib/AutoAffix";
import * as Table from "react-bootstrap/lib/Table";

/* tslint:disable:interface-name */
export interface DetailPageProps extends RouteComponentProps<{}, {}, {}>{
    entity: Entity,
    id: string
    returnUrl: string,
    hideGegevensBlock: boolean
}

class DetailPage extends Component<DetailPageProps, {}> {
    private entity: Entity;
    private propertyDisplayFactory: PropertyDisplayFactory = new PropertyDisplayFactory();
    private titleField: IField;
    private subTitleField?: IField;
    private descriptionField: IField;

    constructor(props: DetailPageProps) {
        super(props);
        this.entity = props.entity;
        this.titleField = this.entity.fields.find(f => (f.behaviors & FieldBehaviors.Title ) !== 0)!;
        this.subTitleField = this.entity.fields.find(f => (f.behaviors & FieldBehaviors.SubTitle) !== 0);
        this.descriptionField = this.entity.fields.find(f => (f.behaviors & FieldBehaviors.Description ) !== 0)!;

    }

    public render() {
        return <Query query={this.getRecordQuery()} variables={{id: decodeURIComponent(this.props.id)}}>
            {({loading, error, data}) => {
                if (error) {
                    console.error(error.message);
                    return error;
                }
                
                if (loading || data[this.entity.id] == null) {
                    return <Row>
                        <Col>
                            <Loader innerClassName={"center-block size-x2"} type="ball-grid-pulse" active={true}/>
                        </Col>
                    </Row>;
                }
                
                const record: any = data[this.entity.id].results[0];
                const ignore = (e: any) => {
                    e.preventDefault();
                    return false;
                };
                const scrollToTop = () =>  window.scrollTo({ top: 0, behavior: 'smooth' });
        return <section id="main" className="detail" style={{backgroundColor: "#f5f5f5"}}>
            <AutoAffix key={"scrollToTop"} bottomClassName="visible-sm-block visible-xs-block"
                       topClassName="hidden"
                       affixClassName="no-text"
                       affixStyle={{right: 0, bottom: 20, top: 'unset'}} autoWidth={false} container={this}>
                <Clearfix>
                    <a
                        className={"listgo-btn btn-primary pull-right"}
                        onClick={scrollToTop}
                    ><i className="fa fa-arrow-up"/>
                    </a>
                </Clearfix>
            </AutoAffix>
            <div className="section listing-single-wrap2">
                <div className="header-page__breadcrumb">
                    <div className="container">
                        <ol className="wo_breadcrumb">
                            <li><Link to={this.props.returnUrl}>Zoekresultaten</Link></li>
                            <li>{this.propertyDisplayFactory.build(this.titleField, record)}</li>
                        </ol>
                    </div>
                </div>
                <Grid>
                    <Row>
                        <Col md={8}>
                            <div className="nav-filter">
                                <Link className="active" to={this.props.returnUrl}>Terug naar zoekresultaten</Link>
                            </div>
                            <div className="listing-single">
                                <div className="listing-single__header">
                                    <div className="heading-title header-title--1 text-left">
                                        <div className="heading-title__h-group">
                                            <h4 className="heading-title__subtitle">{this.titleField.name}</h4>
                                            <h2 className="heading-title__title">{this.propertyDisplayFactory.build(this.titleField, record)}<br/> {this.subTitleField ? <small> ({this.propertyDisplayFactory.build(this.subTitleField, record)})</small> : null}</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={this.props.hideGegevensBlock ? 12 : 8}>
                            <div className="listing-single__media">
                                <Carousel height={300}>
                                    {this.getImageUrls(record).map(url => (
                                    <Carousel.Item key={url}>
                                        <img onContextMenu={ignore} alt={record[this.titleField.id] && record[this.titleField.id].normalize()} src={url} />
                                    </Carousel.Item>
                                    ))}
                                </Carousel>
                            </div>
                            <div className="heading-title header-title--1 text-left">
                                <div className="heading-title__h-group">
                                    <h2 className="heading-title__title">{this.descriptionField.name}</h2>
                                </div>
                                <p className="heading-title__description">{this.propertyDisplayFactory.build(this.descriptionField, record)}</p>
                            </div>
                            {this.entity.fields.filter(f => f.type === FieldType.Enum && (f as EnumField).multiple).map(f => (
                                <div key={f.id} className="multi-enum">
                                    <h3 style={{fontSize: "24px", marginBottom: 0}}>{f.name}</h3>
                                    {this.propertyDisplayFactory.build(f, record)}
                                </div>
                            ))}
                            {this.props.hideGegevensBlock ? <>
                                <h3 style={{fontSize: "24px", marginBottom: 0}}>Overige kenmerken</h3>
                                <div className="other-properties">
                                    <div className="other-properties-inner">
                                        <Table>
                                            <tbody>
                                            {this.entity.fields.filter(f =>
                                                !(f.type === FieldType.Enum && (f as EnumField).multiple)
                                                && !(f.behaviors & FieldBehaviors.Identification)
                                                && !(f.behaviors & FieldBehaviors.Description)
                                                && f.type !== FieldType.Image
                                                && !(f.type === FieldType.Array && (f as ArrayField).innerField.type === FieldType.Image)
                                            ).map(field => (
                                                <tr key={`${field.id}-values`}>
                                                    <th>{field.name}</th>
                                                    <td>{this.propertyDisplayFactory.build(field, record)}</td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </> : undefined}
                        </Col>
                        {this.props.hideGegevensBlock ? undefined :
                        <Col md={4}>
                            <div className="sidebar-background sidebar-background--light">
                                <div className="widget">
                                    <h4 className="widget_title">
                                        <i className="icon_clipboard"/> Gegevens
                                    </h4>
                                    <ul className="widget_author__address">
                                        {this.entity.fields.filter(f => f.type === FieldType.Enum && !(f as EnumField).multiple).map(this.renderSingleEnums.bind(this, record))}
                                        {this.entity.fields.filter(f =>
                                            f.type !== FieldType.Enum
                                            && !(f.behaviors & FieldBehaviors.Identification)
                                            && !(f.behaviors & FieldBehaviors.Description)
                                            && f.type !== FieldType.Image
                                            && !(f.type === FieldType.Array && (f as ArrayField).innerField.type === FieldType.Image)
                                        ).map(field => {
                                            return (
                                                <li key={`widget-gegevens-property-${field.id}`}>
                                                    <strong>{field.name}: </strong>
                                                    {this.propertyDisplayFactory.build(field, record)}
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </Col>}
                    </Row>
                </Grid>
            </div>
        </section>}}
        </Query>;
    }

    private renderSingleEnums(record: any, field : IField) {
        return (
            <li key={`widget-gegevens-property-${field.id}`}>
                <strong>{field.name}: </strong>
                {this.propertyDisplayFactory.build(field, record)}
            </li>
        );
    }

    private getRecordQuery() {
            const inputArgumentBuilder = new InputArgumentTypeFactory(this.props.entity.id);
            const searchableFields = this.entity.fields.filter(f => f.searchable);
            const idField = this.entity.fields.find(f => (f.behaviors & FieldBehaviors.Identification) !== 0)!;
            const q = `
            query getRecord($id:${inputArgumentBuilder.visit(idField)}){
                ${this.entity.id}(${idField.id}: $id) {
                    count,
                    facets {
                        ${searchableFields.filter(f => f.type === FieldType.Enum).map((f: EnumField) => `${f.id} { ${f.options.map(o => o.key.toLowerCase()).join(', \n')}}`).join(',\n')}
                    },
                    results {
                        ${this.entity.fields.map(f => f.type === FieldType.LengthInterval ? `${f.id} { min , max, __typename @skip(if: true) }` : f.id).join(',\n')}
                    }
                }
            }`;
            return gql(q);
    }


    private getImageUrls(record: any[]) : string[] {
        const imageField = this.entity.fields.find(f => f.type === FieldType.Image || (f.type === FieldType.Array && (f as ArrayField).innerField.type === FieldType.Image));
        if (!imageField) {
            return [];
        }
        if (imageField.type === FieldType.Array) {
            const baseUrl = ((imageField as ArrayField).innerField as ImageField).baseUrl;

            return record[imageField.id].map((path: string) => {
                const filename = path;
                const extension = filename.indexOf('.jpg', filename.length - 4) !== -1 ? "" : ".jpg";
                return`${baseUrl}${filename}${extension}`;
            });
        } else {
            const baseUrl = (imageField as ImageField).baseUrl;
            const filename = record[imageField.id];
            const extension = filename.indexOf('.jpg', filename.length - 4) !== -1 ? "" : ".jpg";
            return [`${baseUrl}${filename}${extension}`];
        }
    }
}

export default withRouter(DetailPage);


// WEBPACK FOOTER //
// ./src/pages/client/detailPage.tsx